import t from 'prop-types';

export const total = t.shape({});

export const creditCardPaymentMethod = t.shape({
  cardType: t.string,
  expiryMonth: t.string,
  expiryYear: t.string,
  lastFourDigits: t.string,
});

export const voucherPaymentMethod = t.shape({
  code: t.string,
  brand: t.string,
});

export const pointsPaymentMethod = t.shape({
  qffNumber: t.string,
});

export const creditNotePaymentMethod = t.shape({
  brand: t.string,
  lastFourCharacters: t.string,
  expiry: t.string,
});

const qantasGroupCreditVoucherPaymentMethod = t.shape({
  cardNumber: t.string | null,
});

const qantasTravelPassPaymentMethod = t.shape({
  cardNumber: t.string,
  expiryMonth: t.string,
  expiryYear: t.string,
});

export const paymentBreakdownItem = t.shape({
  total: total.isRequired,
  method: t.oneOf(['credit_card', 'voucher', 'points', 'credit_note', 'qantas_travel_pass', 'qantas_group_credit_voucher']),
  paymentMethods: t.arrayOf(
    t.oneOfType([
      creditCardPaymentMethod,
      voucherPaymentMethod,
      pointsPaymentMethod,
      creditNotePaymentMethod,
      qantasTravelPassPaymentMethod,
      qantasGroupCreditVoucherPaymentMethod,
    ]),
  ).isRequired,
});
